import { render, staticRenderFns } from "./CollectionEdit.vue?vue&type=template&id=bd496eae&scoped=true"
import script from "./CollectionEdit.vue?vue&type=script&lang=js"
export * from "./CollectionEdit.vue?vue&type=script&lang=js"
import style0 from "./CollectionEdit.vue?vue&type=style&index=0&id=bd496eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd496eae",
  null
  
)

export default component.exports